// extracted by mini-css-extract-plugin
module.exports = {"contacts_container":"Contacts_contacts_container__2NGx3","errorMsg":"Contacts_errorMsg__3ownB","feedback_msg":"Contacts_feedback_msg__1iNgM"};